import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-190f1031"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-left":"3vw","padding-right":"3vw","padding-top":"2vw"} }
const _hoisted_2 = { style: {"display":"flex","flex-direction":"row","align-items":"center","margin-bottom":"8px"} }
const _hoisted_3 = { style: {"font-size":"1.5rem","margin-left":"10px"} }
const _hoisted_4 = {
  key: 0,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_5 = { style: {"min-height":"30vw","max-height":"30vw"} }
const _hoisted_6 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_7 = { style: {"display":"flex","flex-direction":"row","min-height":"30vw","max-height":"30vw"} }
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"} }
const _hoisted_9 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_10 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_11 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_13 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_15 = { style: {"min-height":"25vw","max-height":"25vw"} }
const _hoisted_16 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_17 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_19 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_20 = {
  key: 2,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_21 = { style: {"min-height":"30vw","max-height":"30vw"} }
const _hoisted_22 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_23 = { style: {"display":"flex","flex-direction":"row","min-height":"30vw","max-height":"30vw"} }
const _hoisted_24 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_25 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_26 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_27 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_29 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_30 = {
  key: 3,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_31 = { style: {"min-height":"30vw","max-height":"30vw"} }
const _hoisted_32 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_33 = { style: {"display":"flex","flex-direction":"row","min-height":"30vw","max-height":"30vw"} }
const _hoisted_34 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_35 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_36 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_37 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_39 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_40 = {
  key: 4,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_41 = { style: {"min-height":"32vw","max-height":"32vw"} }
const _hoisted_42 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_43 = { style: {"display":"flex","flex-direction":"row","min-height":"32vw","max-height":"32vw"} }
const _hoisted_44 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_45 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_46 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_47 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_49 = {
  key: 5,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_50 = { style: {"min-height":"32vw","max-height":"32vw"} }
const _hoisted_51 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_52 = { style: {"display":"flex","flex-direction":"row","min-height":"32vw","max-height":"32vw"} }
const _hoisted_53 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_54 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_55 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_56 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_58 = {
  key: 6,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_59 = { style: {"min-height":"32vw","max-height":"32vw"} }
const _hoisted_60 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_61 = { style: {"display":"flex","flex-direction":"row","min-height":"32vw","max-height":"32vw"} }
const _hoisted_62 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_63 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_64 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_65 = { style: {"display":"flex","flex-direction":"row","gap":"10px","align-items":"center"} }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_67 = {
  key: 7,
  style: {"display":"flex","flex-direction":"column","gap":"10px"}
}
const _hoisted_68 = { style: {"min-height":"32vw","max-height":"32vw"} }
const _hoisted_69 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black","margin-left":"4px"}
}
const _hoisted_70 = { style: {"display":"flex","flex-direction":"row","min-height":"32vw","max-height":"32vw"} }
const _hoisted_71 = { style: {"display":"flex","flex-direction":"column","align-items":"center"} }
const _hoisted_72 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_73 = {
  class: "app__property--medium",
  style: {"font-weight":"bold","color":"black"}
}
const _hoisted_74 = { style: {"display":"flex","flex-direction":"row","align-items":"center"} }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"15px","height":"auto"},
  src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABApJREFUaEPtV3tMjWEY/52SCrmvi2uhRihMLjVJ/pCae0tktdJFSYdCO25rTTYsOkdHjnKpRM3cynWoqdzmMrcwK9mYZDFy6d6x92w1q/dzvu97szPzPf8+l9/ze37v973PKzNb76bFP2wyiYCB1ZMUMLAAkBSQFGCcgHSEGAfInP5/KdDX3AJ5QTtgYdqDOrnm1hYszdyEqtoaqj/WIwC+zp6cU79R8RCK82pBqghWYImzJ46tSOQEOfOkCMuzt3byOw92QMmagzAx7kbNrf72GdNSgvGh9tPfJUCqa/wUCHTx4QTyO6pAQVlJu9+0mwlKYzIwzmYkp3JeB2Jws/KxoOZJsGAFSFLP7mYolWdgtKUtFZAcoYm7V+Br/Xedf7t3JOJmBXA2F1+QClVxruDmRRMgiWOtR6AkJh3mJqZUYHXpSaw/p8SU4WNRGJUGYyMjatz5slL4ZSqg1Yrb6kUp0NbJKtfF2LsoltpYq7YV3pq1Ov8YK7pSFTXv4KYMbVdKjARMBAhgbmASFoyfScVuaG4COf80+9lUD499EXhaVSGm7/YcZgJ9zHvh7rojGN7PRlAj4Xk7kH3/oqAcWjAzAVJ08lBHFK7ez/mL7Ah86E4+ok/tYm6e6SPuiB4/OwgJXmF6m3ryvhweqRGoa2rQG8snoEsUIEBGMiPkhyZjtoMLJ+6Xum9wVa5E5af3fHrjFdNlBAgaWRWSfCI5gcmqMFcjF/3L/GvfACk8zXY8rqxSobsx/a/TBr7tkga7C7N5TZdPUJcoYN17AG7JD8Gm90C9mOR+mJ8Rh+uv7umN5RPATIAsZ5cjVHC1c+KDp4v5qFvcQji3Vt6FxO5CvwOofTciZOp8IZi62JLXj+CtkYOs4CzGpABpnBCgGdltNuSrkOAVjl6m5tSY5KIcbLmYxtK/uG2UILoMc8TVSDXnqpBy44TucRLk4oMDfgpOkv5Zm5H/rFg0CVEKWFr0xy15Bgb3saQCP3j7Ap7qKDS2NOn85AFEHkI0+1L3Ha7KENF3g2AC5KO9EJ6CGSMmcDY0PSUYbz5XtfvJU/RebCaG9KUTZrmdBRPYs3AdIt2WcEoemJOAk4+udfJ72k9GQdge3Y1Ns4O3z0B+OlnwURJEYNmkOTi8rPN7tw017eYpxJ7dy9nEznnRiHH35/SH5m5HzoPLgkjwJuA0yB5F0WnoYWJGBXhWVQH3feF/XNLI26B4TTqcBo2i1vjRWA93VRieV1fyJsGLAFkPsgISMKyfNbVwi7YFwccTUV7zTi+wo5Ud0v03QwYZNfZF9RuE5SWB3Nh8jBcBPoUMFSMRMNTk23AlBSQFGCcgHSHGATKnSwowj5CxgMwszu0lYw2DptMXEoO2JAz8nyfwCxCFd8zbDrrDAAAAAElFTkSuQmCC"
}, null, -1))
const _hoisted_76 = {
  key: 0,
  style: {"margin-left":"2rem"}
}
const _hoisted_77 = { style: {"font-weight":"bold","color":"black"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_Line = _resolveComponent("Line")!
  const _component_Doughnut = _resolveComponent("Doughnut")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_icon, {
        name: "arrow_back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack())),
        class: "cursor-pointer",
        color: "#273233",
        size: "sm",
        style: {"font-size":"1.5rem"}
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('message.reports')), 1)
    ]),
    (_ctx.chartType == 'inactiveUsers')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('message.users_evolution')), 1),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartData,
                    style: {"cursor":"pointer","min-height":"30vw","max-height":"30vw","width":"100%"},
                    height: 150,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('message.last_month')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPie,
                      style: {"min-width":"22vw","max-width":"22vw"},
                      options: _ctx.optionsPie
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[2] || (_cache[2] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[5] || (_cache[5] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadXLS('inactiveUsers', _ctx.$t('message.users_evolution')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [10],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonth(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  modelValue: _ctx.searchAgent,
                  "onUpdate:modelValue": [
                    _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchAgent) = $event)),
                    _cache[10] || (_cache[10] = ($event: any) => (_ctx.filterAgents()))
                  ],
                  label: _ctx.$t('message.agent2'),
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
                }, null, 8, ["modelValue", "label", "style"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.clickedDetails)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 1,
                "rows-per-page-options": [10],
                rows: _ctx.filteredUsersActiveInactive,
                columns: _ctx.columnsUsersEvolution,
                "visible-columns": _ctx.visibleColumnsUsersEvolution,
                pagination: _ctx.myPagination,
                "row-key": "userid",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: "userid",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.userid), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "firstName",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.firstName), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "lastName",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.lastName), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "companyName",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.companyName), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "agent_name",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.agent_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "status",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.status), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'timeSpent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('message.no_logins_and_time_spent')), 1),
            (_ctx.loadedData)
              ? (_openBlock(), _createBlock(_component_Line, {
                  key: 0,
                  style: {"cursor":"pointer","min-height":"25vw","max-height":"25vw"},
                  height: 100,
                  chartData: _ctx.chartDataUsersTimeSpent,
                  options: _ctx.options
                }, null, 8, ["chartData", "options"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[11] || (_cache[11] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[12] || (_cache[12] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[14] || (_cache[14] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[15] || (_cache[15] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.downloadXLS('timeSpent', _ctx.$t('message.no_logins_and_time_spent')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [10],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonthTimeSpent(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetailsTimeSpent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  modelValue: _ctx.searchAgent,
                  "onUpdate:modelValue": [
                    _cache[19] || (_cache[19] = ($event: any) => ((_ctx.searchAgent) = $event)),
                    _cache[20] || (_cache[20] = ($event: any) => (_ctx.filterAgentsTimeSpent()))
                  ],
                  label: _ctx.$t('message.agent2'),
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
                }, null, 8, ["modelValue", "label", "style"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.clickedDetailsTimeSpent)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 1,
                "rows-per-page-options": [10],
                rows: _ctx.filteredUsersTimeSpent,
                columns: _ctx.columnsUsersTimeSpent,
                "visible-columns": _ctx.visibleColumnsUsersTimeSpent,
                pagination: _ctx.myPagination,
                "row-key": "userid",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: "userid",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.userid), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "first_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.first_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "last_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "denumire",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.denumire), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "agent",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.agent), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "count_login",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.count_login), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "timeSpent",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(Math.round(props.row.timeSpent)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "avgTime",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.avgTime), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'countOffers')
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('message.requests_sent')), 1),
            _createElementVNode("div", _hoisted_23, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartDataCountOffers,
                    style: {"cursor":"pointer","min-height":"30vw","max-height":"30vw","width":"100%"},
                    height: 150,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('message.last_month')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPieOffers,
                      style: {"min-width":"25vw","max-width":"25vw"},
                      options: _ctx.options
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[21] || (_cache[21] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[22] || (_cache[22] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[24] || (_cache[24] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[25] || (_cache[25] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.downloadXLS('countOffers', _ctx.$t('message.requests_sent')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [10],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonthOffers(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetailsOffers)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  modelValue: _ctx.searchAgent,
                  "onUpdate:modelValue": [
                    _cache[29] || (_cache[29] = ($event: any) => ((_ctx.searchAgent) = $event)),
                    _cache[30] || (_cache[30] = ($event: any) => (_ctx.filterOffersCount()))
                  ],
                  label: _ctx.$t('message.agent2'),
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
                }, null, 8, ["modelValue", "label", "style"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.clickedDetailsOffers)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 1,
                "rows-per-page-options": [10],
                rows: _ctx.filteredOffers,
                columns: _ctx.columnsOffers,
                "visible-columns": _ctx.visibleColumnsOffersCount,
                pagination: _ctx.myPagination,
                "row-key": "id_offer",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: "id_offer",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.id_offer), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "first_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.first_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "last_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "denumire",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.denumire), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "status",
                        props: props,
                        style: _normalizeStyle('min-width: 150px;max-width: 150px;font-weight: bold;color: ' + _ctx.statusColor(props.row.status))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.statusHumanReadable(props.row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props", "style"]),
                      _createVNode(_component_q_td, {
                        key: "agent",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.agent), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'quantityOffers')
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('message.offers_quantity_report')), 1),
            _createElementVNode("div", _hoisted_33, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartDataCountOffers,
                    style: {"cursor":"pointer","min-height":"30vw","max-height":"30vw","width":"100%"},
                    height: 150,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('message.last_month')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPieOffers,
                      style: {"min-width":"25vw","max-width":"25vw"},
                      options: _ctx.options
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[31] || (_cache[31] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[32] || (_cache[32] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[34] || (_cache[34] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[35] || (_cache[35] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.downloadXLS('countOffers', _ctx.$t('message.offers_quantity_report')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [10],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonthOffersQuantity(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetailsOffersQuantity)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                _createVNode(_component_q_input, {
                  outlined: "",
                  dense: "",
                  modelValue: _ctx.searchAgent,
                  "onUpdate:modelValue": [
                    _cache[39] || (_cache[39] = ($event: any) => ((_ctx.searchAgent) = $event)),
                    _cache[40] || (_cache[40] = ($event: any) => (_ctx.filterOffersQuantity()))
                  ],
                  label: _ctx.$t('message.agent2'),
                  style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
                }, null, 8, ["modelValue", "label", "style"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.clickedDetailsOffersQuantity)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 1,
                "rows-per-page-options": [10],
                rows: _ctx.filteredOffersQuantity,
                columns: _ctx.columnsOffers,
                "visible-columns": _ctx.visibleColumnsOffersQuantity,
                pagination: _ctx.myPagination,
                "row-key": "id_offer",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: "id_offer",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.id_offer), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "first_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.first_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "last_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "denumire",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.denumire), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "status",
                        props: props,
                        style: _normalizeStyle('min-width: 150px;max-width: 150px;font-weight: bold;color: ' + _ctx.statusColor(props.row.status))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.statusHumanReadable(props.row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props", "style"]),
                      _createVNode(_component_q_td, {
                        key: "agent",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.agent), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "quantity",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(Math.round(props.row.quantity/1000)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'offersTime')
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.$t('message.avg_offers_time_reply')), 1),
            _createElementVNode("div", _hoisted_43, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartDataOffersTimeBetween,
                    style: {"cursor":"pointer","min-height":"32vw","max-height":"32vw","width":"100%"},
                    height: 160,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t('message.last_month')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPieOffers,
                      style: {"min-width":"27vw","max-width":"27vw"},
                      options: _ctx.options
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[41] || (_cache[41] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[42] || (_cache[42] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[44] || (_cache[44] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[45] || (_cache[45] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.downloadXLS('countOffers', _ctx.$t('message.avg_offers_time_reply')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_48
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [20],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination2,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonthOffersTimeBetween(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetailsOffersTimeBetween)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 0,
                "rows-per-page-options": [10],
                rows: _ctx.filteredOffersTimeBetween,
                columns: _ctx.columnsOffers,
                "visible-columns": _ctx.visibleColumnsOffersTime,
                pagination: _ctx.myPagination,
                "row-key": "id_offer",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: "id_offer",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.id_offer), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "first_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.first_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "last_name",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.last_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "denumire",
                        props: props
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.denumire), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "status",
                        props: props,
                        style: _normalizeStyle('min-width: 150px;max-width: 150px;font-weight: bold;color: ' + _ctx.statusColor(props.row.status))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.statusHumanReadable(props.row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props", "style"]),
                      _createVNode(_component_q_td, {
                        key: "time",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(Math.round(props.row.time)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'offersQuantityCategories')
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('message.tons_categories')), 1),
            _createElementVNode("div", _hoisted_52, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartDataCategoriesQuantity,
                    style: {"cursor":"pointer","min-height":"32vw","max-height":"32vw","width":"100%"},
                    height: 150,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t('message.last_month')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPieCategoriesQuantity,
                      style: {"min-width":"26vw","max-width":"26vw"},
                      options: _ctx.options
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[49] || (_cache[49] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[50] || (_cache[50] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[52] || (_cache[52] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[53] || (_cache[53] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.downloadXLS('offersQuantityCategories', _ctx.$t('message.tons_categories')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_57
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [10],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonthCategories(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetailsCategories)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 0,
                "rows-per-page-options": [10],
                rows: _ctx.filteredSubcategories,
                columns: _ctx.columnsSubcategory,
                "visible-columns": _ctx.visibleColumnsSubcategoryQuantity,
                pagination: _ctx.myPagination,
                "row-key": "id_subcategory",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: _ctx.$i18n.locale == 'de' ? 'name_de' : _ctx.$i18n.locale == 'ro' ? 'name_ro' : _ctx.$i18n.locale == 'en' ? 'name_en' : 'name_hu',
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$i18n.locale == 'de' ? props.row.name_de : _ctx.$i18n.locale == 'ro' ? props.row.name_ro : _ctx.$i18n.locale == 'en' ? props.row.name_en : props.row.name_hu), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "quantity",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.transformQuantity(props.row.quantity/1000)), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'offersClicksCategories')
      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t('message.offers_categories_clicks')), 1),
            _createElementVNode("div", _hoisted_61, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartDataCategoriesQuantity,
                    style: {"cursor":"pointer","min-height":"32vw","max-height":"32vw","width":"100%"},
                    height: 160,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('message.last_month')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPieCategoriesQuantity,
                      style: {"min-width":"26vw","max-width":"26vw"},
                      options: _ctx.options
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.startDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.start_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.startDate,
                      "onUpdate:modelValue": [
                        _cache[57] || (_cache[57] = ($event: any) => ((_ctx.startDate) = $event)),
                        _cache[58] || (_cache[58] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_input, {
              outlined: "",
              dense: "",
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.endDate) = $event)),
              mask: "##.##.####",
              label: _ctx.$t('message.end_date'),
              style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);margin-left: 2rem;'),
              "input-style": { fontWeight: 'bolder' }
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "event",
                  class: "cursor-pointer"
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_q_popup_proxy, {
                  ref: "qDateProxy0",
                  "transition-show": "scale",
                  "transition-hide": "scale"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_date, {
                      modelValue: _ctx.endDate,
                      "onUpdate:modelValue": [
                        _cache[60] || (_cache[60] = ($event: any) => ((_ctx.endDate) = $event)),
                        _cache[61] || (_cache[61] = () => _ctx.$refs.qDateProxy0.hide())
                      ],
                      mask: "DD.MM.YYYY",
                      locale: _ctx.myLocale
                    }, null, 8, ["modelValue", "locale"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["modelValue", "label", "style"]),
            _createVNode(_component_q_btn, {
              label: _ctx.$t('message.apply_filter'),
              style: {"background-color":"#9b7d32","color":"white"},
              size: "md",
              "no-caps": "",
              onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.loadData()))
            }, null, 8, ["label"]),
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.downloadXLS('offersQuantityCategories', _ctx.$t('message.offers_categories_clicks')))),
              size: "md",
              style: {"margin-left":"20px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_66
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [10],
            rows: _ctx.months,
            columns: _ctx.columnsMonths,
            "visible-columns": _ctx.visibleColumnsMonths,
            pagination: _ctx.myPagination,
            "row-key": "userid"
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row, (row) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: row['name'],
                      props: props,
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.selectMonthCategories(row, props.rowIndex)),
                      class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, row['name']) })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row['value']), 1)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick", "class"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns", "pagination"]),
          (_ctx.clickedDetailsCategories)
            ? (_openBlock(), _createBlock(_component_q_table, {
                key: 0,
                "rows-per-page-options": [10],
                rows: _ctx.filteredSubcategories,
                columns: _ctx.columnsSubcategory,
                "visible-columns": _ctx.visibleColumnsSubcategoryCount,
                pagination: _ctx.myPagination,
                "row-key": "id_subcategory",
                title: _ctx.selectedMonth
              }, {
                body: _withCtx((props) => [
                  _createVNode(_component_q_tr, { props: props }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_td, {
                        key: _ctx.$i18n.locale == 'de' ? 'name_de' : _ctx.$i18n.locale == 'ro' ? 'name_ro' : _ctx.$i18n.locale == 'en' ? 'name_en' : 'name_hu',
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$i18n.locale == 'de' ? props.row.name_de : _ctx.$i18n.locale == 'ro' ? props.row.name_ro : _ctx.$i18n.locale == 'en' ? props.row.name_en : props.row.name_hu), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"]),
                      _createVNode(_component_q_td, {
                        key: "countClicks",
                        props: props,
                        style: {"min-width":"200px","max-width":"200px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.countClicks), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 1
              }, 8, ["rows", "columns", "visible-columns", "pagination", "title"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.chartType == 'basket')
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$t('message.users_with_products_in_basket')), 1),
            _createElementVNode("div", _hoisted_70, [
              (_ctx.loadedData)
                ? (_openBlock(), _createBlock(_component_Line, {
                    key: 0,
                    chartData: _ctx.chartDataBasket,
                    style: {"cursor":"pointer","min-height":"32vw","max-height":"32vw","width":"100%"},
                    height: 160,
                    options: _ctx.options
                  }, null, 8, ["chartData", "options"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('message.users_with_products_in_basket')), 1),
                (_ctx.loadedData)
                  ? (_openBlock(), _createBlock(_component_Doughnut, {
                      key: 0,
                      chartData: _ctx.chartDataPieBasket,
                      style: {"min-width":"26vw","max-width":"26vw"},
                      options: _ctx.options
                    }, null, 8, ["chartData", "options"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.totalPieTitle) + ": " + _toDisplayString(_ctx.total), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createVNode(_component_q_btn, {
              "no-caps": "",
              loading: _ctx.downloadingXLS,
              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.downloadXLS('basket', _ctx.$t('message.users_with_products_in_basket')))),
              size: "md",
              style: {"margin-left":"2rem"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('message.export')) + " XLS", 1),
                _createVNode(_component_q_avatar, { size: "15px" }, {
                  default: _withCtx(() => [
                    _hoisted_75
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createVNode(_component_q_table, {
            dense: "",
            "rows-per-page-options": [],
            rows: _ctx.agentsBasket,
            columns: _ctx.columnsBasket,
            pagination: {rowsPerPage:0},
            "visible-columns": _ctx.visibleColumnsBasket,
            "row-key": "userid",
            style: {"margin-left":"2rem"}
          }, {
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, {
                props: props,
                onClick: ($event: any) => (_ctx.selectBasketAgent(props.row, props.rowIndex)),
                style: {"cursor":"pointer"},
                class: _normalizeClass({ 'bold-label': _ctx.isCellSelected(props.rowIndex, '') })
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, {
                    key: "agent",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.firstName) + " " + _toDisplayString(props.row.lastName), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "no_clients",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(props.row.users.length), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "tons",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getTotalQuantityUsers(props.row.users)), 1)
                    ]),
                    _: 2
                  }, 1032, ["props"])
                ]),
                _: 2
              }, 1032, ["props", "onClick", "class"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "visible-columns"]),
          (_ctx.clickedAgentBasket)
            ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.selectedAgentBasket.firstName) + " " + _toDisplayString(_ctx.selectedAgentBasket.lastName) + "       " + _toDisplayString(_ctx.$t('message.no_users')) + ": " + _toDisplayString(_ctx.selectedAgentBasket.users.length) + "       " + _toDisplayString(_ctx.$t('message.tons')) + ": " + _toDisplayString(_ctx.getTotalQuantityUsers(_ctx.selectedAgentBasket.users)), 1),
                _createVNode(_component_q_table, {
                  dense: "",
                  "rows-per-page-options": [10],
                  rows: _ctx.selectedAgentBasket.users,
                  columns: _ctx.columnsOffersBasket,
                  pagination: _ctx.myPagination,
                  "visible-columns": _ctx.visibleColumnsBasketQuantity,
                  "row-key": "userid"
                }, {
                  body: _withCtx((props) => [
                    _createVNode(_component_q_tr, { props: props }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, {
                          key: "userid",
                          props: props,
                          style: {"min-width":"200px","max-width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.userid), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "first_name",
                          props: props,
                          style: {"min-width":"200px","max-width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.first_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "last_name",
                          props: props,
                          style: {"min-width":"200px","max-width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.last_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "denumire",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.row.denumire), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: _ctx.$i18n.locale == 'de' ? 'category_name_de' : _ctx.$i18n.locale == 'ro' ? 'category_name_ro' : _ctx.$i18n.locale == 'en' ? 'category_name_en' : 'category_name_hu',
                          props: props,
                          style: {"min-width":"200px","max-width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$i18n.locale == 'de' ? props.row.category_name_de : _ctx.$i18n.locale == 'ro' ? props.row.category_name_ro : _ctx.$i18n.locale == 'en' ? props.row.category_name_en : props.row.category_name_hu), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "qum2",
                          props: props,
                          style: {"min-width":"200px","max-width":"200px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.transformQuantity(props.row.qum2/1000)), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  ]),
                  _: 1
                }, 8, ["rows", "columns", "pagination", "visible-columns"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}